import { API_TYPES, useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { z } from "zod";

const getEngagedWorkplacesSchema = z.object({
  data: z.array(
    z.object({
      type: z.literal(API_TYPES.workplace),
      id: z.string(),
      attributes: z
        .object({
          name: z.string(),
          type: z.string(),
        })
        .strict(),
    })
  ),
});

type GetEngagedWorkplaces = z.infer<typeof getEngagedWorkplacesSchema>;

interface GetPlacementWorkplacesParams {
  placementCandidateId: string;
}

export function useGetEngagedWorkplaces(
  params: GetPlacementWorkplacesParams,
  options?: UseGetQueryOptions<GetEngagedWorkplaces>
) {
  const { placementCandidateId } = params;
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/placement-candidates/${placementCandidateId}/engaged-workplaces`,
    responseSchema: getEngagedWorkplacesSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PLACEMENT_WORKPLACES_FAILURE,
      userErrorMessage: "Something went wrong while loading the workplaces.",
    },
    ...options,
  });
}
